import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Join from "@/pages/Join";
import NewCount from "@/pages/NewCount";
import History from "@/pages/History";
import CountDetail from "@/pages/CountDetail";
import Employees from "@/pages/Employees";
import Settings from "@/pages/Settings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/join/:token" element={<Join />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<NewCount />} />
              <Route path="/history" element={<History />} />
              <Route path="/history/:id" element={<CountDetail />} />
              <Route path="/employees" element={<Employees />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
